import { inject, Injectable } from "@angular/core";
import { DownloadFileResponse, DownloadStandardRelevanceGQL, GetStandardRelevanceGQL, GetStandardRelevanceQuery, GetStandardRiskmapFiltersGQL, GetStandardRiskmapFiltersQuery, RelevanceTemplateInput, RiskMapTemplateQueryComplexInput, RiskMapTemplateSortInput, UpdateStandardRelevanceGQL, UpdateStandardRelevanceMutation, UploadExcelStandardRelevanceGQL, UploadExcelStandardRelevanceMutation } from "../../../graphql/generated";
import { map, Observable } from "rxjs";
import { convertLazyLoadToComplexWithoutPage } from "./standard-riskmap.service";

@Injectable({
    providedIn: 'root'
})
export class StandardRelevanceService {
    private readonly GetStandardRelevanceGQL: GetStandardRelevanceGQL = inject(GetStandardRelevanceGQL);
    private readonly DownloadStandardRelevanceGQL: DownloadStandardRelevanceGQL = inject(DownloadStandardRelevanceGQL);
    private readonly UploadExcelStandardRelevanceGQL: UploadExcelStandardRelevanceGQL = inject(UploadExcelStandardRelevanceGQL);
    private readonly UpdateStandardRelevanceGQL: UpdateStandardRelevanceGQL = inject(UpdateStandardRelevanceGQL);
    private readonly GetStandardRiskmapFiltersGQL: GetStandardRiskmapFiltersGQL = inject(GetStandardRiskmapFiltersGQL);

    getStandardRelevance(
        size: string,
        typeOfBusiness: string,
        valueChain: string,
        year: string,
        parameters: any,
        au: boolean | null
    ): Observable<GetStandardRelevanceQuery['relevanceTemplateByValueChainAndTypeOfBusinessAndSizeAndYear']> {
        const param = convertLazyLoadToComplexWithoutPage(parameters);
        return this.GetStandardRelevanceGQL.fetch({ size, typeOfBusiness, valueChain, year: Number(year), query: param.query as RiskMapTemplateQueryComplexInput, sort: param.sort as RiskMapTemplateSortInput, au }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.relevanceTemplateByValueChainAndTypeOfBusinessAndSizeAndYear))
    }

    updateStandardRelevance(
        riskRelevanceTemplates: RelevanceTemplateInput[]
    ): Observable<UpdateStandardRelevanceMutation['updateRelevanceTemplateByIds']> {
        return this.UpdateStandardRelevanceGQL.mutate({ riskRelevanceTemplates }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.updateRelevanceTemplateByIds))
    }

    downloadStandardRelevance(
        parameters: any,
        timeZone: string,
        year: number,
        valueChain: string,
        typeOfBusiness: string,
        size: string
    ): Observable<DownloadFileResponse[]> {
        const param = convertLazyLoadToComplexWithoutPage(parameters);
        return this.DownloadStandardRelevanceGQL.mutate({ query: param.query as RiskMapTemplateQueryComplexInput, sort: param.sort as RiskMapTemplateSortInput, timeZone, year, size, typeOfBusiness, valueChain }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.downloadRelevanceTemplateByQuery?.data as DownloadFileResponse[]))
    }

    uploadExcel(
        base64ExcelFile: string
    ): Observable<UploadExcelStandardRelevanceMutation['importRelevanceTemplateFromExcel']> {
        return this.UploadExcelStandardRelevanceGQL.mutate({ base64ExcelFile }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.importRelevanceTemplateFromExcel))
    }

    getFilers(au: boolean | null, size: string, typeOfBusiness: string, valueChain: string, year: string): Observable<GetStandardRiskmapFiltersQuery['riskMapTemplateFilters']> {
        return this.GetStandardRiskmapFiltersGQL.fetch({ au, size, typeOfBusiness, valueChain, year }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data.riskMapTemplateFilters))
    }
}